export default __webpack_public_path__ + "f35702660c7611d27db5693d9546ef4e.png";